import { ConfigProvider, ThemeConfig, theme } from 'antd'
import { AliasToken } from 'antd/es/theme/internal'
import { useTheme } from 'next-themes'

const { darkAlgorithm, defaultAlgorithm } = theme

const AntdThemeProvider = ({ children }) => {
  const { theme: _theme } = useTheme()

  const token: Partial<AliasToken> = {
    controlInteractiveSize: 24,
    fontFamily: 'Bricolage-Grotesque, sans-serif',
    fontSize: 16,
    colorPrimary: '#00349D',
    borderRadius: 8,
    controlHeight: 40,
    controlHeightSM: 32,
    controlHeightLG: 56,
  }

  const AntdThemeConfig: ThemeConfig = {
    algorithm: _theme === 'dark' ? darkAlgorithm : defaultAlgorithm,
    token,
    components: {
      Button: {
        fontWeight: 700,
        paddingContentHorizontal: 24,
        paddingContentHorizontalSM: 16,
        paddingContentHorizontalLG: 24,
      },
      Slider: {
        handleActiveColor: '#CEDCF1',
        railBg: '#5283CD',
        railHoverBg: '#5283CD',
        trackBg: '#CEDCF1',
        trackHoverBg: '#CEDCF1',
        railSize: 8,
        handleSize: 16,
        dotSize: 16,
      },
    },
  }

  return <ConfigProvider theme={AntdThemeConfig}>{children}</ConfigProvider>
}

export default AntdThemeProvider
